import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {StyledDropdownGroupTitleWrapper} from '../../rules/ruleEditor/ruleEditorCommons';
import {MethodCategoriesEnum} from './infer/method';

/*
 * Props.
 */

interface AtomGroupTitleProps {
  id: MethodCategoriesEnum;
}

/*
 * Component.
 */

export const AtomGroupTitle: FC<AtomGroupTitleProps> = (props) => {
  const {id} = props;

  return <StyledDropdownGroupTitleWrapper>{getTitle(id)}</StyledDropdownGroupTitleWrapper>;
};

/*
 * Helpers.
 */

const getTitle = (id: MethodCategoriesEnum) => {
  switch (id) {
    case MethodCategoriesEnum.PROPERTY:
      return <Trans id="editor-expression-atom-group-title-properties">Properties</Trans>;

    case MethodCategoriesEnum.ITEM:
      return <Trans id="editor-expression-atom-group-title-item">Pick list elements</Trans>;

    case MethodCategoriesEnum.TRANSFORM:
      return <Trans id="editor-expression-atom-group-title-transform">Transform</Trans>;

    case MethodCategoriesEnum.COMPARE:
      return <Trans id="editor-expression-atom-group-title-compare">Compare</Trans>;

    case MethodCategoriesEnum.PARSE:
      return <Trans id="editor-expression-atom-group-title-parse">Parse</Trans>;

    case MethodCategoriesEnum.CONVERT:
      return <Trans id="editor-expression-atom-group-title-convert">Convert</Trans>;

    case MethodCategoriesEnum.EXTRACT:
      return <Trans id="editor-expression-atom-group-title-extract">Extract</Trans>;

    case MethodCategoriesEnum.CUSTOM_FIELD:
      return <Trans id="editor-expression-atom-group-title-custom-field">Custom fields</Trans>;

    case MethodCategoriesEnum.CREATE:
      return <Trans id="editor-expression-atom-group-title-create">Create</Trans>;

    case MethodCategoriesEnum.SERVER:
      return <Trans id="editor-expression-atom-group-title-server">Servers</Trans>;

    default:
      return id;
  }
};
